import { Quote } from "lucide-react";
import { Card } from "@/components/ui/card";

interface TestimonialSectionProps {
  quote: string;
  authorName: string;
  authorTitle: string;
}

export const TestimonialSection = ({ quote, authorName, authorTitle }: TestimonialSectionProps) => {
  if (!quote || !authorName) return null;

  return (
    <div className="border-t pt-12 mt-12">
      <h2 className="text-3xl font-bold mb-6">What Founders Say</h2>
      <Card className="p-8 bg-secondary/20 border-none">
        <Quote className="w-10 h-10 text-accent mb-4" />
        <blockquote className="text-xl text-foreground mb-6 leading-relaxed">
          "{quote}"
        </blockquote>
        <div className="border-t pt-4">
          <p className="font-semibold text-lg">{authorName}</p>
          <p className="text-muted-foreground">{authorTitle}</p>
        </div>
      </Card>
    </div>
  );
};
